import React from 'react';

export const MetricColumnRenderer = (name: string): React.ReactNode =>
  name === 'Score & Tier' ? <b>{name}</b> : name;
